module.exports = __webpack_public_path__ + "img/hired-logo.2059cbf3.png";